import { UNBLOCK_USER, UNBLOCK_USER_ERROR, UNBLOCK_USER_HIDE_ERROR, UNBLOCK_USER_START_LOADER, UNBLOCK_USER_STOP_LOADER, } from "../interface/iUnblockUser";
const initState = {
    data: {
        success: false,
        userID: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const unblockUser = (state = initState, action) => {
    switch (action.type) {
        case UNBLOCK_USER: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case UNBLOCK_USER_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case UNBLOCK_USER_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case UNBLOCK_USER_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case UNBLOCK_USER_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default unblockUser;
